<template>
	<sf-data-table
		ref="Table"
		paging
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		:columns="cols"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		:stripe="false"
		:selection="false"
		:customExcel="excelFunc"
		@changedPage="changedPage"
		index
	>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/qlty/ClamRepay/store/helpers';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import
/*엑셀다운로드 시작*/
import utils from '@/utils';
import moment from 'moment';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import { BASE_URL } from '@/constants';
/*엑셀다운로드 끝*/

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			//그리드 로우
			return this.clamRepayList;
		},
		cols() {
			//그리드 컬럼
			return [
				// {
				// 	label: this.getMessage_('QWCC001225'), //클레임 번호
				// 	prop: 'clmNo',
				// 	width: '200px',
				// 	align: 'center',
				// 	highlight: true,
				// 	clickEvent: this.openClamEditModal
				// },
				{
					label: this.getMessage_('QWCC000976'), //R/O No
					prop: 'roNo',
					width: '150px',
					align: 'center',
					highlight: true,
					clickEvent: this.openClamNewModal
				},
				{
					label: this.getMessage_('QWCC001056'), //Ctype
					prop: 'ctypeNm',
					width: '200px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000956'), //품번
					prop: 'causPartNo',
					width: '150px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000957'), //품명
					prop: 'causPartNm',
					width: '300px',
					headerAlign: 'center',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC000958'), // 협력사
					prop: 'aplCpnyNm',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001924'), // 실납품사
					prop: 'aplDlvgNm',
					width: '200px',
					headerAlign: 'center'
				},
				{
					label: this.getMessage_('QWCC001055'), // 현상코드
					prop: 'phmnCd',
					width: '100px',
					align: 'center'
				},

				{
					label: this.getMessage_('QWCC001070'), // 현상명
					prop: 'phmnNm',
					width: '300px',
					headerAlign: 'center',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC001029'), //원인코드
					prop: 'causCd',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001308'), //원인명
					prop: 'causNm',
					width: '300px',
					headerAlign: 'center',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC000980'), // 클레임확정일
					prop: 'dcsnDd',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001053'), // 사용기간
					prop: 'usePrd',
					width: '100px',
					headerAlign: 'center',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC000972'), // 주행거리
					prop: 'milg',
					width: '100px',
					headerAlign: 'center',
					align: 'right'
				},

				{
					label: this.getMessage_('QWCC001538'), // 제품 ID
					prop: 'pmcId',
					width: '200px',
					align: 'center'
				},

				{
					label: this.getMessage_('QWCC001304'), //'클레임 금액,
					width: '40px',
					align: 'center',
					children: [
						{
							label: this.getMessage_('QWCC001101'), //자재비
							width: '100px',
							prop: 'mtrlCst',
							align: 'right'
						},
						{
							label: this.getMessage_('QWCC001102'), //'공임비',
							width: '100px',
							prop: 'wags',
							align: 'right'
						},
						{
							label: this.getMessage_('QWCC001103'), //'부대비',
							width: '100px',
							prop: 'incdCst',
							align: 'right'
						},
						{
							label: this.getMessage_('QWCC001104'), //'총금액',
							width: '100px',
							prop: 'totPartCst',
							align: 'right'
						}
					]
				}

				// {
				// 	label: this.getMessage_('QWCC001858'), // 변제예상 분담율
				// 	prop: 'dvswRt',
				// 	align: 'right',
				// 	width: '150px'
				// },
				// {
				// 	label: this.getMessage_('QWCC001510'), // 변제예상금액
				// 	prop: 'rpymAmt',
				// 	align: 'right',
				// 	width: '150px'
				// },
				// {
				// 	label: this.getMessage_('QWCC000963'), // 처리단계
				// 	prop: 'prcsStepNm',
				// 	width: '100px',
				// 	align: 'center'
				// },
				// {
				// 	label: this.getMessage_('QWCC001305'), // 적용 분담율
				// 	prop: 'aplDvswRt',
				// 	width: '150px',
				// 	align: 'right'
				// },
				// {
				// 	label: this.getMessage_('QWCC001306'), // 적용 변제금액
				// 	prop: 'aplRpymAmt',
				// 	width: '150px',
				// 	align: 'right'
				// },
				// {
				// 	label: this.getMessage_('QWCC000978'), // 처리결과
				// 	prop: 'prcsRsltNm',
				// 	width: '199px',
				// 	align: 'center'
				// }
			];
		},
		ExcelCols() {
			//그리드 컬럼
			return [
				// {
				// 	label: this.getMessage_('QWCC001225'), //클레임 번호
				// 	prop: 'clmNo',
				// 	width: '200px',
				// 	align: 'center',
				// 	highlight: true,
				// 	clickEvent: this.openClamEditModal
				// },
				{
					label: this.getMessage_('QWCC000976'), //R/O No
					prop: 'roNo',
					width: '200px',
					align: 'center',
					highlight: true,
					clickEvent: this.openClamNewModal
				},
				{
					label: this.getMessage_('QWCC001056'), //Ctype
					prop: 'ctypeNm',
					width: '200px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000956'), //품번
					prop: 'causPartNo',
					width: '200px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000957'), //품명
					prop: 'causPartNm',
					width: '300px',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC000958'), // 협력사
					prop: 'aplCpnyNm',
					width: '150px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001924'), // 실납품사
					prop: 'aplDlvgNm',
					width: '200px',
					headerAlign: 'center'
				},
				{
					label: this.getMessage_('QWCC001055'), // 현상코드
					prop: 'phmnCd',
					width: '100px',
					align: 'center'
				},

				{
					label: this.getMessage_('QWCC001070'), // 현상명
					prop: 'phmnNm',
					width: '300px',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC001029'), //원인코드
					prop: 'causCd',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001308'), //원인명
					prop: 'causNm',
					width: '300px',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC000980'), // 클레임확정일
					prop: 'dcsnDd',
					width: '120px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001053'), // 사용기간
					prop: 'usePrd',
					width: '150px',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC000972'), // 주행거리
					prop: 'milg',
					width: '150px',
					align: 'right'
				},

				{
					label: this.getMessage_('QWCC001538'), // 제품 ID
					prop: 'pmcId',
					width: '100px',
					align: 'center'
				},

				{
					label: this.getMessage_('QWCC001101'), //자재비
					width: '100px',
					prop: 'mtrlCst',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC001102'), //'공임비',
					width: '100px',
					prop: 'wags',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC001103'), //'부대비',
					width: '100px',
					prop: 'incdCst',
					align: 'right'
				},
				{
					label: this.getMessage_('QWCC001104'), //'총금액',
					width: '100px',
					prop: 'totPartCst',
					align: 'right'
				}
				// {
				// 	label: this.getMessage_('QWCC001858'), // 변제예상분담율
				// 	prop: 'dvswRt',
				// 	align: 'right',
				// 	width: '150px'
				// },
				// {
				// 	label: this.getMessage_('QWCC001510'), // 변제예상금액
				// 	prop: 'rpymAmt',
				// 	align: 'right',
				// 	width: '150px'
				// },
				// {
				// 	label: this.getMessage_('QWCC000963'), // 처리단계
				// 	prop: 'prcsStepNm',
				// 	width: '100px',
				// 	align: 'center'
				// },
				// {
				// 	label: this.getMessage_('QWCC001305'), // 적용 분담율
				// 	prop: 'aplDvswRt',
				// 	width: '150px',
				// 	align: 'right'
				// },
				// {
				// 	label: this.getMessage_('QWCC001306'), // 적용 변제금액
				// 	prop: 'aplRpymAmt',
				// 	width: '150px',
				// 	align: 'right'
				// },
				// {
				// 	label: this.getMessage_('QWCC000978'), // 처리결과
				// 	prop: 'prcsRsltNm',
				// 	width: '199px',
				// 	align: 'center'
				// }
			];
		}
	},
	methods: {
		...serviceMethods,
		...utils, //커스텀 엑셀다운로드시
		excelFunc() {
			//커스텀 엑셀다운로드시 필요한 함수
			let queryStr = '';

			/*날짜 포멧변환*/
			let startDcsnDd, endDcsnDd, causPartNo;

			//날짜 값이 없으면 날짜 포멧을 할수가 없다.

			if (this.searchParams.startDcsnDd) {
				startDcsnDd = moment(this.searchParams.startDcsnDd).format('YYYYMMDD');
			} else {
				startDcsnDd = '';
			}

			if (this.searchParams.endDcsnDd) {
				endDcsnDd = moment(this.searchParams.endDcsnDd).format('YYYYMMDD');
			} else {
				endDcsnDd = '';
			}

			/*특수문자가 있는것들은 다음과 같이해줘됨 */
			if (this.searchParams.causPartNo) {
				causPartNo = encodeURIComponent(this.searchParams.causPartNo);
			} else {
				causPartNo = '';
			}

			queryStr = objectToQuerystring({
				dlrCpnyCd: this.searchParams.dlrCpnyCd /*딜러점*/,
				causPartNo: causPartNo /*품번*/,
				ctype: this.searchParams.ctype /* ctype*/,
				prcStepGb: this.searchParams.prcStepGb /*처리단계*/,
				prcRsltCd: this.searchParams.prcRsltCd /*처리결과*/,
				prcClmDd: this.searchParams.prcClmDd /* 검색날짜구분값*/,
				roNo: this.searchParams.roNo /* 검색날짜구분값*/,
				startDcsnDd: startDcsnDd /*확정일자from*/,
				endDcsnDd: endDcsnDd /*확정일자to*/
			});

			const url = `${BASE_URL}/mqy/qlty/clamRepay/v1/excels` + queryStr;

			const params = { url, columns: this.ExcelCols };
			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		},
		resetTable() {
			this.$emit('Refresh');
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
			}

			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });

			this.$emit('Refresh', currentPageVal, pageUnitVal);
		},
		openClamNewModal(row) {
			/*pwa 상세조회*/

			const selRoNo = convertNvl(row.roNo, '');

			const selClmNo = convertNvl(row.clmNo, '');

			const param = {
				title: this.getMessage_('QWCC001769'), //클레임 신청
				roNo: row.roNo
			};
			// console.log('값은>>>>', row);
			// if (selRoNo != '' && selClmNo == '') {
			// }
			this.$emit('PopupClamMstNewOpen', param); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.
		},
		openClamEditModal(row) {
			/*RO신청 버튼 클릭시*/
			//console.log('그리드에서 클레임번호를 클릭했을때>', row);

			const selClmNo = convertNvl(row.clmNo, '');

			if (selClmNo != '') {
				const param = {
					title: this.getMessage_('QWCC001774'), //클레임 상세
					clmNo: row.clmNo
				};
				this.$emit('PopupClamMstOpen', param); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.
			} else {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('QWCC001330'),
					message: this.getMessage_('MWCC000110')
				}); //클레임 번호가 등록된 행을 선택해주세요./ 선택된 데이터가 없습니다.
				return;
			}
		}
	}
};
</script>

<style></style>
